import React from "react";
import { ReactComponent as LogoTampon } from "../assets/images/logoTampon.svg";
import { ReactComponent as LogoAlpeHuez } from "../assets/images/alpeHuez.svg";
import { ReactComponent as Logo2Alpes } from "../assets/images/2Alpes.svg";
import { ReactComponent as LogoLaGrave } from "../assets/images/laGrave.svg";
import { ReactComponent as Instagram } from "../assets/icons/instagram.svg";
import { ReactComponent as LinkedIn } from "../assets/icons/linkedin.svg";
import { ReactComponent as Youtube } from "../assets/icons/ytb.svg";
import style from "./block.module.scss";
import { BlockWrapper } from "@smartfire/js-block-engine";
import clsx from "clsx";

function Block({ menu, customSettings, mainMenu = null }) {
  return (
    <BlockWrapper.Div
      className={style.footer}
      itemScope
      itemType="https://schema.org/Organization"
    >
      <div className={style.firstSection}>
        <div className={style.logo}>
          <a href={"/"}>
            <LogoTampon />
          </a>
        </div>
        <div className={clsx(style.logos)}>
          {customSettings.alpeHuezUrl ? (
            <a className={style.link} href={customSettings.alpeHuezUrl}>
              <LogoAlpeHuez />
            </a>
          ) : (
            <LogoAlpeHuez />
          )}
          {customSettings.les2AlpesUrl ? (
            <a className={style.link} href={customSettings.les2AlpesUrl}>
              <Logo2Alpes />
            </a>
          ) : (
            <Logo2Alpes />
          )}
          {customSettings.laGraveUrl ? (
            <a className={style.link} href={customSettings.laGraveUrl}>
              <LogoLaGrave />
            </a>
          ) : (
            <LogoLaGrave />
          )}
        </div>
        <div className={clsx(style.col, style.mainMenuWrapper)}>
          {mainMenu &&
            Object.values(mainMenu).map((m, index) => {
              const hasChildren = Object.values(m.children).length > 0;
              return (
                <div key={index}>
                  <p>{m.title}</p>
                  {hasChildren && (
                    <ul className={style.mainMenu}>
                      {Object.values(m.children).map((m, index) => (
                        <li key={index}>
                          <a href={m.url} title={m.title}>
                            {m.title}
                          </a>
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              );
            })}
        </div>
      </div>
      <div className={style.footerNavContainer}>
        <nav className={style.footerNav}>
          <div className={style.rsLogoContainer}>
            {customSettings.youtubeUrl && (
              <a
                href={customSettings.youtubeUrl}
                target="_blank"
                rel="noreferrer noopener"
                title="YouTube"
                className={style.rsLogo}
                style={{ zIndex: 3 }}
              >
                <Youtube />
              </a>
            )}
            {customSettings.instagramUrl && (
              <a
                href={customSettings.instagramUrl}
                target="_blank"
                rel="noreferrer noopener"
                title="Instagram"
                className={style.rsLogo}
                style={{ zIndex: 2 }}
              >
                <Instagram />
              </a>
            )}
            {customSettings.linkedinUrl && (
              <a
                href={customSettings.linkedinUrl}
                target="_blank"
                rel="noreferrer noopener"
                title="LinkedIn"
                className={style.rsLogo}
              >
                <LinkedIn />
              </a>
            )}
          </div>
          {menu && (
            <div className={style.secondaryMenu}>
              <ul>
                {Object.values(menu).map((m, index) => (
                  <li key={index}>
                    <a href={m.url} title={m.title}>
                      {m.title}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </nav>
      </div>
    </BlockWrapper.Div>
  );
}

export default Block;
